import { useFetchMixAPi1, useMixApi1Toast } from "hooks";
import { getURLWithParams } from "utils/context";

export const useCbenefReportsCasosTotal = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/reports/cbenf-total-casos`, params));

export const useCbenefReportsCasosLista = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/reports/cbenf-casos`, params));

export const useCbenef = (params = {}) =>
  useFetchMixAPi1(getURLWithParams(`/legislacao/cbenef`, params));

export const useCbenefShow = id =>
  useFetchMixAPi1(`/legislacao/cbenef/detalhe/${id}`);

export const useCbenefDestroy = id => {
  useFetchMixAPi1(`/legislacao/cbenef/detalhe/${id}`);
};

export const useCbenefNovo = id => {
  const { isLoading, data, onSend } = useMixApi1Toast();

  const cBenefCreate = async data => {
    const endpoint = id
      ? `/legislacao/cbenef/detalhe/${id}`
      : "/legislacao/cbenef/novo";
    const type = id ? "PUT" : "POST";

    const res = await onSend({
      endpoint,
      messageSucess: "Sucesso!",
      messageFail: `Requisição falhou!`,
      type,
      data,
    });
    return res;
  };

  const onRemove = id =>
    onSend({
      endpoint: `/legislacao/cbenef/detalhe/${id}`,
      messageSuccess: `Código Benefício deletado!`,
      messageFail: "Erro ao deletar!",
      type: "DELETE",
    });

  return {
    onRemove,
    cBenefCreate,
    isLoading,
    data,
  };
};
